import { resolveComponent as _resolveComponent, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_time_line = _resolveComponent("time-line")!
  const _component_SpinnerVue = _resolveComponent("SpinnerVue")!

  return (_openBlock(), _createBlock(_Suspense, null, {
    default: _withCtx(() => [
      _createVNode(_component_time_line)
    ]),
    fallback: _withCtx(() => [
      _createVNode(_component_SpinnerVue)
    ]),
    _: 1
  }))
}